import React, { useState, useCallback } from "react"
import Alert from "@mui/material/Alert"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import { useSnackbar } from "notistack"
import { verifyResponse, httpPost } from "utils/httpRequest"

const getErrorMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback

const McpUsersDialog = ({ onSubmit, onCloudConfig }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const openDialog = useCallback(() => {
    setEmail("")
    setError(null)
    setOpen(true)
  }, [])

  const closeDialog = useCallback(() => {
    setOpen(false)
    setEmail("")
    setError(null)
  }, [])

  const handleSubmit = async () => {
    setError(null)

    if (!email.trim()) {
      setError("Email is required")
      return
    }

    setLoading(true)
    try {
      const response = await httpPost("admin/mcp-users", {
        email: email.trim(),
      })
      verifyResponse(response.data)
      const cloudConfig =
        response.data?.data?.data?.cloudConfig ||
        response.data?.data?.cloudConfig
      closeDialog()
      onSubmit()
      if (cloudConfig && onCloudConfig) {
        onCloudConfig(cloudConfig, "MCP User Created — Cloud Config")
      }
    } catch (err) {
      const message = getErrorMessage(err, "Failed to save user")
      setError(message)
      enqueueSnackbar(message, { variant: "error" })
    } finally {
      setLoading(false)
    }
  }

  if (!open) {
    return [openDialog, null, false, closeDialog]
  }

  const dialogContent = (
    <div>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <div className="form-group">
        <label>
          Email <span className="required">*</span>
        </label>
        <TextField
          fullWidth
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="user@company.com"
          variant="outlined"
          size="small"
        />
      </div>

      <p
        style={{
          fontSize: 13,
          color: "var(--cms-text-secondary, #64748b)",
          margin: "8px 0 0",
        }}
      >
        A secure password will be generated automatically and shown after
        creation.
      </p>

      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          Create
        </Button>
        <Button variant="outlined" onClick={closeDialog} disabled={loading}>
          Cancel
        </Button>
      </div>
    </div>
  )

  return [openDialog, dialogContent, loading, closeDialog]
}

export default McpUsersDialog
